import * as go from 'gojs';
import { findExtremeZOrders, getBackLayer, setOrderingProps } from './utils';

const moveBackNodeAndParents = (
  part: go.Part,
  zOrder: number,
  layerName: string,
  zOrderProp?: string,
  layerProp?: string,
) => {
  if (!part) {
    return;
  }

  setOrderingProps(part, zOrder, layerName, zOrderProp, layerProp);
  if (part.containingGroup) {
    moveBackNodeAndParents(part.containingGroup, zOrder - 1, layerName, zOrderProp, layerProp);
  }
};

export const sendToBack = (part: go.Part, zOrderProp?: string, layerProp?: string) => {
  if (!part) {
    return;
  }

  if (part instanceof go.Group) {
    part.memberParts.each((p) => sendToBack(p, zOrderProp, layerProp));
  }

  if (part.diagram) {
    const backLayer = getBackLayer(part.diagram);
    if (backLayer) {
      const { lowestZOrder } = findExtremeZOrders(backLayer);
      part.diagram.commit(() => {
        moveBackNodeAndParents(part, lowestZOrder - 1, backLayer.name, zOrderProp, layerProp);
      });
    }
  }
};
